var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 82,
    viewBox: "0 0 111 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 6,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 6,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 6,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 6,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 6,
    width: 9,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 6,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 6,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 6,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 6,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 16,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 16,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 16,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 16,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 16,
    width: 9,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 16,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 16,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 16,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 16,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 26,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 26,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 26,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 26,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 26,
    width: 9,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 26,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 26,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 26,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 26,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 36,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 36,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 36,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 36,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 36,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 36,
    width: 9,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 36,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 36,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 36,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 36,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 46,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 46,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 46,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 46,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 46,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 46,
    width: 9,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 46,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 46,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 46,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 46,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 56,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 56,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 56,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 56,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 56,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 56,
    width: 9,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 56,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 56,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 56,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 56,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 66,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 66,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 66,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 66,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 66,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 66,
    width: 9,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 66,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 66,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 66,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 66,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.34375 29.4512C7.23918 29.4512 6.34375 28.5557 6.34375 27.4512L6.34375 8.35258C6.34375 7.24801 7.23918 6.35258 8.34375 6.35258L102.506 6.35258C103.61 6.35258 104.506 7.24801 104.506 8.35258V29.4512L8.34375 29.4512Z",
    fill: "#EDE1E4",
    stroke: "#794E57",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4063 75.4512C82.3017 75.4512 81.4062 74.5557 81.4062 73.4512V29.3512H104.506V73.4512C104.506 74.5557 103.611 75.4512 102.506 75.4512H83.4063Z",
    fill: "#EDE1E4",
    stroke: "#794E57",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77465 0H105H105.099H111V76V82H105H81V76H105V5.77465H5.77465V76H56V82H5.77465H0V76V5.77465V0H5.77465Z",
    fill: "#DCDCDC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.759 56.3224C93.1464 56.3224 93.48 56.2781 93.76 56.1894C94.04 56.1007 94.2687 55.9771 94.446 55.8184C94.628 55.6551 94.761 55.4637 94.845 55.2444C94.929 55.0204 94.971 54.7754 94.971 54.5094C94.971 53.9914 94.7867 53.5831 94.418 53.2844C94.0494 52.9811 93.4964 52.8294 92.759 52.8294H90.589V56.3224H92.759ZM90.589 48.4404V51.8634H92.381C92.7637 51.8634 93.095 51.8214 93.375 51.7374C93.6597 51.6534 93.893 51.5367 94.075 51.3874C94.2617 51.2381 94.3994 51.0584 94.488 50.8484C94.5767 50.6337 94.621 50.4004 94.621 50.1484C94.621 49.5557 94.4437 49.1241 94.089 48.8534C93.7344 48.5781 93.1837 48.4404 92.437 48.4404H90.589ZM92.437 47.3694C93.053 47.3694 93.5827 47.4301 94.026 47.5514C94.474 47.6727 94.8404 47.8454 95.125 48.0694C95.4144 48.2934 95.6267 48.5687 95.762 48.8954C95.8974 49.2174 95.965 49.5814 95.965 49.9874C95.965 50.2347 95.9254 50.4727 95.846 50.7014C95.7714 50.9254 95.657 51.1354 95.503 51.3314C95.349 51.5274 95.153 51.7047 94.915 51.8634C94.6817 52.0174 94.4064 52.1434 94.089 52.2414C94.8264 52.3814 95.3794 52.6451 95.748 53.0324C96.1214 53.4151 96.308 53.9191 96.308 54.5444C96.308 54.9691 96.2287 55.3564 96.07 55.7064C95.916 56.0564 95.6874 56.3574 95.384 56.6094C95.0854 56.8614 94.7167 57.0574 94.278 57.1974C93.8394 57.3327 93.34 57.4004 92.78 57.4004H89.238V47.3694H92.437Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0338 19.1783L55.4588 15.0973C55.4121 14.976 55.3631 14.836 55.3118 14.6773C55.2604 14.514 55.2114 14.3413 55.1648 14.1593C55.0668 14.5373 54.9664 14.8523 54.8638 15.1043L53.2888 19.1783H57.0338ZM59.8618 22.9023H58.8118C58.6904 22.9023 58.5924 22.872 58.5178 22.8113C58.4431 22.7507 58.3871 22.6737 58.3498 22.5803L57.4118 20.1583H52.9108L51.9728 22.5803C51.9448 22.6643 51.8911 22.739 51.8118 22.8043C51.7324 22.8697 51.6344 22.9023 51.5178 22.9023H50.4678L54.4788 12.8713H55.8508L59.8618 22.9023Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLShape);
export default __webpack_public_path__ + "static/media/l-shape.f86f6ff8136d6c2800b59dc51f0a481f.svg";
export { ForwardRef as ReactComponent };